export enum PageType {
  INBOX = 'inbox',
  SENT = 'sent',
  DRAFT = 'draft',
  SPAM = 'spam',
  TRASH = 'trash',
  ALL = 'all',
  LABELS = 'labels',
  DOBOX = 'dobox',
  ARCHIVE = 'archive',
  SNOOZED = 'snoozed',
  UNKNOWN = 'unknown',
}

export const PAGE_TYPES = {
  INBOX: PageType.INBOX,
  SENT: PageType.SENT,
  DRAFT: PageType.DRAFT,
  SPAM: PageType.SPAM,
  TRASH: PageType.TRASH,
  ALL: PageType.ALL,
  LABELS: PageType.LABELS,
  DOBOX: PageType.DOBOX,
  ARCHIVE: PageType.ARCHIVE,
  SNOOZED: PageType.SNOOZED,
  UNKNOWN: PageType.UNKNOWN,
} as const;

export type Page = (typeof PAGE_TYPES)[keyof typeof PAGE_TYPES];
